import { createFileRoute } from '@tanstack/react-router';

const TopPage = () => {
  return <>Top Page</>;
};

export const Route = createFileRoute('/')({
  component: TopPage,
  head: () => ({
    meta: [
      {
        title: 'TOP | FMS Console V2',
      },
    ],
  }),
});
